import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.988 9.70996H7.008C6.598 9.70996 6.258 9.36996 6.258 8.95996C6.258 8.54996 6.598 8.20996 7.008 8.20996H16.988C17.398 8.20996 17.738 8.54996 17.738 8.95996C17.738 9.36996 17.398 9.70996 16.988 9.70996Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 9.71101C11.59 9.71101 11.25 9.37101 11.25 8.96101V7.28101C11.25 6.87101 11.59 6.53101 12 6.53101C12.41 6.53101 12.75 6.87101 12.75 7.28101V8.96101C12.75 9.37101 12.41 9.71101 12 9.71101ZM7 17.471C6.59 17.471 6.25 17.131 6.25 16.721C6.25 16.311 6.59 15.971 7 15.971C10.72 15.971 13.75 12.821 13.75 8.94101C13.75 8.53101 14.09 8.19101 14.5 8.19101C14.91 8.19101 15.25 8.53101 15.25 8.94101C15.25 13.651 11.55 17.471 7 17.471Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.001 17.47C15.031 17.47 13.201 16.49 11.861 14.7C11.7417 14.5409 11.6904 14.3409 11.7185 14.1439C11.7467 13.947 11.8519 13.7694 12.011 13.65C12.1701 13.5307 12.3702 13.4794 12.5671 13.5075C12.764 13.5357 12.9417 13.6409 13.061 13.8C14.121 15.2 15.521 15.97 17.011 15.97C17.421 15.97 17.761 16.31 17.761 16.72C17.761 17.13 17.411 17.47 17.001 17.47Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }